/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov, Tabitha Bleil
 */

import React from "react"
import { Element, Label } from "trux"
import { ContactEdit } from "./ContactEdit"

const ContactsEdit = (props) => {
    const addContact = (e) => {
        e.preventDefault()
        props.onAddContact()
    }

    const removeContact = (e) => {
        e.preventDefault()
        var indexStr = e.currentTarget.id.replace("remove-", "")
        var index = parseInt(indexStr, 10)
        props.onRemoveContact(index)
    }

    const handleOnNameChanged = (value, id) => {
        let iid = id.replace("name-", "")
        let index = parseInt(iid, 10)

        props.onNameChanged(index, value, "", "")
    }

    const onEmailChanged = (value, id) => {
        let iid = id.replace("email-", "")
        let index = parseInt(iid, 10)

        props.onEmailChanged(index, value)
    }

    const yesUseMatching = (e) => {
        if (e) {
            e.preventDefault()
        }

        let id = `${e.currentTarget.id}`
        id = id.replace("yes-", "")

        let index = parseInt(id, 10)
        if (props.useDuplicateContact) {
            props.useDuplicateContact(index, true)
        }
    }

    const noAddingNew = (e) => {
        if (e) {
            e.preventDefault()
        }

        let id = `${e.currentTarget.id}`
        id = id.replace("no-", "")

        let index = parseInt(id, 10)
        if (props.useDuplicateContact) {
            props.useDuplicateContact(index, false)
        }
    }

    var contacts = props.contacts ? props.contacts : []

    return (
        <Element>
            {contacts.map((contact, index) => (
                <ContactEdit
                    key={`contacts-edit-${index}`}
                    contact={contact}
                    index={index}
                    duplicateEmails={props.duplicateEmails}
                    removeContact={removeContact}
                    handleOnNameChanged={handleOnNameChanged}
                    onEmailChanged={onEmailChanged}
                    yesUseMatching={yesUseMatching}
                    noAddingNew={noAddingNew}
                    validate={props.validate}
                />
            ))}

            <Element paddingTop="4">
                <Element tag="a" href="#add-family-member" onClick={addContact}>
                    <Label bold center content="Add Family Member" />
                </Element>
            </Element>
        </Element>
    )
}

export default ContactsEdit
